import { CompositeFilterDescriptor, FilterDescriptor } from '@progress/kendo-data-query'
import { DealDtoFilterKey, DealDtoKey } from 'api/Clients/Types/DealDto'
import { BuildQueryProps } from 'utils/QueryHelpers'

export const normalizeDealsSearchQuery = (
  filterDescriptor: CompositeFilterDescriptor
): BuildQueryProps => {
  const gridFilterDescriptor = filterDescriptor as CompositeFilterDescriptor
  const filters =
    gridFilterDescriptor?.filters.map((x: FilterDescriptor | CompositeFilterDescriptor) => {
      const filterItem = x as FilterDescriptor

      if (filterItem.field === DealDtoKey.introducingBroker) {
        return {
          ...filterItem,
          field: DealDtoFilterKey.introducingBrokerName,
          value: filterItem?.value,
        }
      }

      if (filterItem.field === DealDtoKey.tradingAccount) {
        return {
          ...filterItem,
          field: DealDtoFilterKey.tradingAccountName,
          value: filterItem?.value,
        }
      }

      return filterItem
    }) || []

  return { ...gridFilterDescriptor, filters }
}
